import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { promoCodes } from 'src/constants/promoCodes'
import { commonTitleText } from 'src/modules/utils/constants'
export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      offerBanner={{
        title: [
          'Service members enjoy a special offer through GOVX',
          'Save $30 on your first month of Fubo',
        ],
      }}
      offerCode={promoCodes.govX}
      title={commonTitleText.streamLiveTVSports}
      subtitle={'Stream your favorite teams, shows & more from any device.'}
      showRSN={true}
      noIndex={true}
    />
  )
}
